import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface NavItemProps {
  routeUrl: string;
  title: string;
  clickHandler: () => void;
}

const NavItem: FC<NavItemProps> = (props) => {
  const { routeUrl, title, clickHandler } = props;
  const navigate = useNavigate();

  return (
    <Stack
      onClick={() => {
        clickHandler();
        navigate(routeUrl);
      }}
      className={`${routeUrl === "/" ? "active" : ""}`}
      sx={{
        width: "100%",
        padding: "1em",
        boxSizing: "border-box",
        display: "flex",
        marginTop: "0.5em",
        "&:hover": {
          // background: "#f0fff0", // Changes background color on hover
          cursor: "pointer", // Adds a pointer cursor
          // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Add shadow effect
          color: "rgb(25, 118, 210)", // Add pointer cursor
          fontWeight: "bold"
        },
        "&.active": {
          // background: "rgb(25, 118, 210)", // Changes background color on hover
          cursor: "pointer", // Adds a pointer cursor
          // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Add shadow effect
          color: "rgb(25, 118, 210)", // Add pointer cursor
          fontWeight: "bold"
        }
      }}
    >
      <Typography variant="body1" paddingLeft="0.5em" fontWeight="bold">
        {title}
      </Typography>
    </Stack>
  );
};

export default NavItem;
